import { render, staticRenderFns } from "./StartsJeKlasse.vue?vue&type=template&id=587af49a&scoped=true&"
import script from "./StartsJeKlasse.vue?vue&type=script&lang=js&"
export * from "./StartsJeKlasse.vue?vue&type=script&lang=js&"
import style0 from "./StartsJeKlasse.vue?vue&type=style&index=0&id=587af49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587af49a",
  null
  
)

export default component.exports